<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <br />
    <v-card class="card">
      <v-card-title class="heading justify-center">Manage Results</v-card-title>
      <v-card-text>
        <v-container fluid>
          <template>
            <v-data-table
              :headers="headers"
              :items="array"
              class="elevation-1"
              :search="search"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Manage Results</v-toolbar-title>
                  <v-divider class="mx-10" inset vertical></v-divider>
                  <!-- <v-spacer></v-spacer> -->
                  <v-text-field
                    v-model="search"
                    append-icon="search"
                    label="Search"
                    single-line
                    hide-details
                  ></v-text-field>
                  <span style="width: 20px"></span>
                </v-toolbar>
              </template>
              <template v-slot:item.value="{ item }">
                <v-icon
                  v-if="item.value == 'true'"
                  color="success"
                  class="mr-2"
                  >mdi-check-circle-outline</v-icon
                >
                <v-icon v-else color="error" class="mr-2"
                  >mdi-close-circle-outline</v-icon
                >
              </template>
              <template v-slot:item.actions="{ item }">
                <v-switch
                  v-model="item.value == 'true'"
                  flat
                  @change="editItem(item)"
                  inset
                ></v-switch>
              </template>
            </v-data-table>
          </template>
        </v-container>
      </v-card-text>
    </v-card>
    <v-overlay :value="overlay">
      <v-progress-circular
        class="text-center"
        :size="70"
        :width="5"
        color="primary"
        indeterminate
      ></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import "@/assets/css/color.css";
import axios from "axios";
export default {
  data: () => ({
    color: "",
    snackbar: false,
    snackbar_msg: "",
    overlay: false,
    array: [],
    search: "",
    switch1: true,
    switch2: false,
    headers: [
      { text: "Name", value: "name" },
      {
        text: "Show / Hide",
        value: "value",
        sortable: false,
      },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  mounted() {
    this.onLoad();
  },
  methods: {
    onLoad() {
      this.overlay = true;
      axios
        .post("/COE/manageResults")
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.array = res.data.main_array;
            // this.showSnackbar("#4caf50", "Result status changed!");
          } else {
            this.overlay = false;
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    editItem(value) {
      console.log("value: " + value);
      this.overlay = true;
      const data = {
        id: value.id,
      };
      axios
        .post("/COE/changeResultStatus", data)
        .then((res) => {
          this.overlay = false;
          if (res.data.msg == "200") {
            this.onLoad();
            this.showSnackbar("#4caf50", "Result status changed...");
          } else {
            this.overlay = false;
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          }
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style>
</style>